// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/home/user/upos-dev/app/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelMBrand0 from '/home/user/upos-dev/app/src/models/m_Brand.js';
import ModelMCashCollections1 from '/home/user/upos-dev/app/src/models/m_CashCollections.js';
import ModelMCatalog2 from '/home/user/upos-dev/app/src/models/m_Catalog.js';
import ModelMCategory3 from '/home/user/upos-dev/app/src/models/m_Category.js';
import ModelMCategoryOption4 from '/home/user/upos-dev/app/src/models/m_CategoryOption.js';
import ModelMCategoryOptionGroup5 from '/home/user/upos-dev/app/src/models/m_CategoryOptionGroup.js';
import ModelMDashboard6 from '/home/user/upos-dev/app/src/models/m_Dashboard.js';
import ModelMDeliveryConfig7 from '/home/user/upos-dev/app/src/models/m_DeliveryConfig.js';
import ModelMDigitalSignage8 from '/home/user/upos-dev/app/src/models/m_DigitalSignage.js';
import ModelMFilterForm9 from '/home/user/upos-dev/app/src/models/m_FilterForm.js';
import ModelMGlobal10 from '/home/user/upos-dev/app/src/models/m_Global.js';
import ModelMImage11 from '/home/user/upos-dev/app/src/models/m_Image.js';
import ModelMInventoryCatalog12 from '/home/user/upos-dev/app/src/models/m_InventoryCatalog.js';
import ModelMInventoryStock13 from '/home/user/upos-dev/app/src/models/m_InventoryStock.js';
import ModelMInventoryUom14 from '/home/user/upos-dev/app/src/models/m_InventoryUOM.js';
import ModelMLogs15 from '/home/user/upos-dev/app/src/models/m_Logs.js';
import ModelMMalls16 from '/home/user/upos-dev/app/src/models/m_Malls.js';
import ModelMMallUploadConfig17 from '/home/user/upos-dev/app/src/models/m_MallUploadConfig.js';
import ModelMMallUploadFile18 from '/home/user/upos-dev/app/src/models/m_MallUploadFile.js';
import ModelMMenuBulkEdit19 from '/home/user/upos-dev/app/src/models/m_MenuBulkEdit.js';
import ModelMMenuItem20 from '/home/user/upos-dev/app/src/models/m_MenuItem.js';
import ModelMMenuItemOption21 from '/home/user/upos-dev/app/src/models/m_MenuItemOption.js';
import ModelMMenuItemOptionGroup22 from '/home/user/upos-dev/app/src/models/m_MenuItemOptionGroup.js';
import ModelMMenuStatus23 from '/home/user/upos-dev/app/src/models/m_MenuStatus.js';
import ModelMOutlets24 from '/home/user/upos-dev/app/src/models/m_Outlets.js';
import ModelMPaymentType25 from '/home/user/upos-dev/app/src/models/m_PaymentType.js';
import ModelMPolicy26 from '/home/user/upos-dev/app/src/models/m_Policy.js';
import ModelMPolicyGroup27 from '/home/user/upos-dev/app/src/models/m_PolicyGroup.js';
import ModelMPosDiscount28 from '/home/user/upos-dev/app/src/models/m_PosDiscount.js';
import ModelMPosLanguage29 from '/home/user/upos-dev/app/src/models/m_PosLanguage.js';
import ModelMPosTerminals30 from '/home/user/upos-dev/app/src/models/m_PosTerminals.js';
import ModelMPosVersions31 from '/home/user/upos-dev/app/src/models/m_PosVersions.js';
import ModelMProductCatalog32 from '/home/user/upos-dev/app/src/models/m_ProductCatalog.js';
import ModelMPromotions33 from '/home/user/upos-dev/app/src/models/m_Promotions.js';
import ModelMReports34 from '/home/user/upos-dev/app/src/models/m_Reports.js';
import ModelMRequestLog35 from '/home/user/upos-dev/app/src/models/m_RequestLog.js';
import ModelMSectors36 from '/home/user/upos-dev/app/src/models/m_Sectors.js';
import ModelMSetting37 from '/home/user/upos-dev/app/src/models/m_Setting.js';
import ModelMSettlement38 from '/home/user/upos-dev/app/src/models/m_Settlement.js';
import ModelMStaff39 from '/home/user/upos-dev/app/src/models/m_Staff.js';
import ModelMSuppliers40 from '/home/user/upos-dev/app/src/models/m_Suppliers.js';
import ModelMTerminals41 from '/home/user/upos-dev/app/src/models/m_Terminals.js';
import ModelMTransactionItems42 from '/home/user/upos-dev/app/src/models/m_TransactionItems.js';
import ModelMTransactions43 from '/home/user/upos-dev/app/src/models/m_Transactions.js';
import ModelMUserSession44 from '/home/user/upos-dev/app/src/models/m_UserSession.js';
import ModelMXeroInvoice45 from '/home/user/upos-dev/app/src/models/m_XeroInvoice.js';
import ModelMXeroInvoiceConfig46 from '/home/user/upos-dev/app/src/models/m_XeroInvoiceConfig.js';
import ModelMXeroMapping47 from '/home/user/upos-dev/app/src/models/m_XeroMapping.js';
import ModelMXeroUser48 from '/home/user/upos-dev/app/src/models/m_XeroUser.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'm_Brand', ...ModelMBrand0 });
app.model({ namespace: 'm_CashCollections', ...ModelMCashCollections1 });
app.model({ namespace: 'm_Catalog', ...ModelMCatalog2 });
app.model({ namespace: 'm_Category', ...ModelMCategory3 });
app.model({ namespace: 'm_CategoryOption', ...ModelMCategoryOption4 });
app.model({ namespace: 'm_CategoryOptionGroup', ...ModelMCategoryOptionGroup5 });
app.model({ namespace: 'm_Dashboard', ...ModelMDashboard6 });
app.model({ namespace: 'm_DeliveryConfig', ...ModelMDeliveryConfig7 });
app.model({ namespace: 'm_DigitalSignage', ...ModelMDigitalSignage8 });
app.model({ namespace: 'm_FilterForm', ...ModelMFilterForm9 });
app.model({ namespace: 'm_Global', ...ModelMGlobal10 });
app.model({ namespace: 'm_Image', ...ModelMImage11 });
app.model({ namespace: 'm_InventoryCatalog', ...ModelMInventoryCatalog12 });
app.model({ namespace: 'm_InventoryStock', ...ModelMInventoryStock13 });
app.model({ namespace: 'm_InventoryUOM', ...ModelMInventoryUom14 });
app.model({ namespace: 'm_Logs', ...ModelMLogs15 });
app.model({ namespace: 'm_Malls', ...ModelMMalls16 });
app.model({ namespace: 'm_MallUploadConfig', ...ModelMMallUploadConfig17 });
app.model({ namespace: 'm_MallUploadFile', ...ModelMMallUploadFile18 });
app.model({ namespace: 'm_MenuBulkEdit', ...ModelMMenuBulkEdit19 });
app.model({ namespace: 'm_MenuItem', ...ModelMMenuItem20 });
app.model({ namespace: 'm_MenuItemOption', ...ModelMMenuItemOption21 });
app.model({ namespace: 'm_MenuItemOptionGroup', ...ModelMMenuItemOptionGroup22 });
app.model({ namespace: 'm_MenuStatus', ...ModelMMenuStatus23 });
app.model({ namespace: 'm_Outlets', ...ModelMOutlets24 });
app.model({ namespace: 'm_PaymentType', ...ModelMPaymentType25 });
app.model({ namespace: 'm_Policy', ...ModelMPolicy26 });
app.model({ namespace: 'm_PolicyGroup', ...ModelMPolicyGroup27 });
app.model({ namespace: 'm_PosDiscount', ...ModelMPosDiscount28 });
app.model({ namespace: 'm_PosLanguage', ...ModelMPosLanguage29 });
app.model({ namespace: 'm_PosTerminals', ...ModelMPosTerminals30 });
app.model({ namespace: 'm_PosVersions', ...ModelMPosVersions31 });
app.model({ namespace: 'm_ProductCatalog', ...ModelMProductCatalog32 });
app.model({ namespace: 'm_Promotions', ...ModelMPromotions33 });
app.model({ namespace: 'm_Reports', ...ModelMReports34 });
app.model({ namespace: 'm_RequestLog', ...ModelMRequestLog35 });
app.model({ namespace: 'm_Sectors', ...ModelMSectors36 });
app.model({ namespace: 'm_Setting', ...ModelMSetting37 });
app.model({ namespace: 'm_Settlement', ...ModelMSettlement38 });
app.model({ namespace: 'm_Staff', ...ModelMStaff39 });
app.model({ namespace: 'm_Suppliers', ...ModelMSuppliers40 });
app.model({ namespace: 'm_Terminals', ...ModelMTerminals41 });
app.model({ namespace: 'm_TransactionItems', ...ModelMTransactionItems42 });
app.model({ namespace: 'm_Transactions', ...ModelMTransactions43 });
app.model({ namespace: 'm_UserSession', ...ModelMUserSession44 });
app.model({ namespace: 'm_XeroInvoice', ...ModelMXeroInvoice45 });
app.model({ namespace: 'm_XeroInvoiceConfig', ...ModelMXeroInvoiceConfig46 });
app.model({ namespace: 'm_XeroMapping', ...ModelMXeroMapping47 });
app.model({ namespace: 'm_XeroUser', ...ModelMXeroUser48 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
